// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76c7c574","453":"2a67e059","455":"1aab0ad7","977":"536c31c5"}[chunkId] + ".chunk.js";
};